<template>
  <div>
    <table class="dep-table">
      <thead>
        <tr>
          <th>SN</th>
          <th>Code</th>
          <th>Item</th>
          <th>Lot No.</th>
          <th class="text-center">Quantity</th>
          <th class="text-center">Unit</th>
          <!-- <th class="text-right">Sales Rate</th> -->
          <!-- <th class="text-right">Pur. Rate</th> -->
          
          <!-- <th class="text-right">Amount</th> -->
        </tr> 
      </thead>

      <tbody>
        <tr v-for="(product, key) in directRecieve?.details" :key="product.product_id || key">
          <td>{{ key + 1 }}</td>
          <td>{{ product?.product?.code || '' }}</td>
          <td>{{ product?.product?.name || '' }}</td>
          <td>{{ product?.lot_no }}</td>
          <td class="text-center">{{ product?.qty || 0 }}</td>
          <td class="text-center">{{ product?.product?.unit?.name || '' }}</td>
          <!-- <td class="text-right">{{ $numberFormat(product?.sales_rate || 0) }}</td> -->
          <!-- <td class="text-right">{{ $numberFormat(product?.rate || 0) }}</td> -->
          <!-- <td class="text-right">{{ $numberFormat(product?.total || (product?.qty * product?.rate) || 0) }}</td> -->
        </tr>
        
        <tr v-if="directRecieve?.inv_dr_receive_details?.length === 0">
          <td colspan="7" class="text-center">No product details found</td>
        </tr>
      </tbody>
    </table>
  
    
    <!-- <table class="total-table">
      <tbody>
        <tr>
          <td style="width: 70%;">
            <strong>TOTAL AMOUNT</strong><br>
            <strong>Amount in Words: </strong>{{ convertNumberToWords(directRecieve?.amount || 0) }}
          </td>
          <td style="width: 30%;" class="text-right">
            <strong>{{ $numberFormat(directRecieve?.amount || 0) }}</strong>
          </td>
        </tr>
      </tbody>
    </table> -->
    
    <div v-if="remarks" class="remarks-section">
      <strong>Remarks:</strong> {{ remarks }}
    </div>
      
  </div>
</template>

<script>
import convertNumberToWords from '@/plugins/numberToWord';

export default {
  name: "slsLcRecieveDetailsTable",
  data() {
    return {
      directRecieve: null,
      
    };
  },
  
  computed: {},
  watch: {},
  created() {},
  methods: {
    convertNumberToWords
  },
  setup(props, { emit }) { },
  
  mounted() {
    const id = this.$route.query.referenceable_id;

    this.$store.dispatch('getInvLcReceiveById', id)
      .then((res) => {
        this.directRecieve = res;
      })

  },
};  

</script>

<style scoped>
.full-height {
  min-height: 60vh;
}

.grey-lighten-3 {
  background-color: #eeeeee !important;
}

.report-paper {
  background: white;
}

.company-name {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.company-text {
  font-size: 14px;
}

.report-title {
  font-size: 20px;
  text-align: center;
  margin: 8px 0;
}

.meta-box {
  border: 1px solid #000 !important;
  padding: 8px;
  font-size: 13px;
  margin: 8px 0;
}

.meta-table {
  width: 100%;
  border-collapse: collapse;
  
}

.dep-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.dep-table th,
.dep-table td {
  border: 1px solid #000;
  padding: 6px;
}

.dep-table th {
  background: #e0e0e0;
}

.total-section {
  margin: 20px 0;
}

.total-table {
  width: 100%;
  margin-bottom: 20px;
}

.remarks-section {
  margin: 20px 0;
  padding: 10px;
  border: 1px solid #ddd;
}

.signature-section {
  margin-top: 50px;
}

.signature-line {
  border-top: 1px solid #555;
  width: 200px;
  margin: 0 auto;
  text-align: center;
  color: #333;
  padding-top: 10px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.supplier-name {
  font-weight: bold;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  opacity: 0.1;
}

.page-header {
  margin-bottom: 20px;
}

.header-section {
  margin-bottom: 20px;
}

.company-info {
  flex: 1;
}

.logo-container {
  flex-shrink: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>